import { getContextSearchUtilities } from '@consumer/context-search-utility-loader';

export default async function importContextSearchUtilityBundle() {
    const { showContextSearchSideBar, on } = await getContextSearchUtilities();
    return {
        showContextSearchSideBar,
        on,
    };
}
